import React, { useEffect, useState } from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoaderAnimation from "./LoaderAnimationLarge";

const EditCTScanAssignRegister = ({ assignData, ctscanAssignedRadioData }) => {
  const [loading, setLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    console.log("REQUEST NODE DATA", assignData);
    console.log("REQUEST NODE ID", assignData?.request_nid);

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}/session/token`,
          { credentials: "include" }
        );
        const token = await res.text();
        setCsrfToken(token);
      } catch (err) {
        console.error("Error fetching CSRF token:", err);
      }
    })();
  }, [assignData]);

  const [ctscanrequestStatus, setctscanrequestStatus] = useState(
    assignData?.request_nid || ""
  );
  const [ctscanAssignedRadioLogist, setctscanAssignedRadioLogist] =
    useState("");

  // const [ctscanAssignedRadioLogist, setctscanAssignedRadioLogist] = useState(
  //   data?.ct_scan_assigned_radiologistNID || ""
  // );

  const handleSubmitAssigned = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!assignData?.request_nid) {
      console.log("Error: Missing request ID.");
      // setIsMessageModalVisibleAssigned(true);
      setLoading(false);
      return;
    }

    try {
      const ctrequestAssignedPayload = {
        type: [{ target_id: "ct_scan_request" }],
        field_assigned_radiologist: [{ target_id: ctscanAssignedRadioLogist }],
        field_ct_scan_request_status: [{ value: ctscanrequestStatus }],
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/node/${assignData?.request_nid}?_format=json`,
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify(ctrequestAssignedPayload),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        console.log(`Error: ${error.message}`);
        // setModalMessages(`Error: ${error.message}`);
        // setIsMessageModalIsNotOk(true);
        setLoading(false);
        return;
      }

      setctscanAssignedRadioLogist("");
      setctscanrequestStatus("");
      // setIsMessageModalVisibleAssigned(true);
      await Promise.all([
        // mutate(`${process.env.REACT_APP_CT_SCAN_REQUEST_URL}`),
        // mutate(`${process.env.REACT_APP_CT_SCAN_REPORT_URL}`),
        // mutate(`${process.env.REACT_APP_CT_SCAN_ASSIGNED_REQUEST_URL}`),
      ]);
    } catch (error) {
      // setIsMessageModalVisibleAssigned(false);
    }
  };

  if (!assignData?.request_nid) {
    return <LoaderAnimation loadingTxt="Loading request data..." />;
  }

  return (
    <div className="edit-ctscan-request-register">
      <form onSubmit={handleSubmitAssigned} className="edit-patient-form">
        <div className="form-group">
          <label htmlFor="assign-radiologist">Assigned Radiologist</label>
          <select
            value={ctscanAssignedRadioLogist}
            onChange={(e) => {
              setctscanAssignedRadioLogist(e.target.value);
              console.log("Selected Radiologist:", e.target.value);
            }}
            required
          >
            <option value="">Select Radiologist</option>
            {ctscanAssignedRadioData?.map((ctscanradiologist) => (
              <option
                key={ctscanradiologist?.uid}
                value={ctscanradiologist?.uid}
              >
                {ctscanradiologist?.field_first_name}{" "}
                {ctscanradiologist?.field_last_name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="field_request-status">Status</label>
          <select
            value={ctscanrequestStatus}
            onChange={(e) => setctscanrequestStatus(e.target.value)}
            required
          >
            <option key="none">Select Status</option>
            <option key="pending" value={"pending"}>
              Pending
            </option>
            <option key="assigned" value={"assigned"}>
              Assigned
            </option>
            <option key="completed" value={"completed"}>
              Completed
            </option>
            <option key="cancelled" value={"cancelled"}>
              Cancelled
            </option>
          </select>
        </div>
        <div className="submitGroup">
          <button type="submit">
            {loading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                strokeWidth={20}
                fontSize={22}
              />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCTScanAssignRegister;
